<div class="wrapper">
  <table>
    <ng-content></ng-content>
    @if (!loading && !total) {
    <un-empty
      class="m-36"
      [icon]="icon"
      [description]="emptyDescription"
      [btnText]="btnText"
      [btnLink]="btnLink"
    ></un-empty>
    }
  </table>
</div>
<un-pagniation [total]="total"></un-pagniation>
